import React, { useEffect, useState, useRef } from 'react';
import aboutSection2 from '../../assets/images/about/about_section_2.png';

function AboutSection2() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05, // 섹션이 30% 이상 보일 때 트리거
        rootMargin: '-20px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="md:h-[647px] w-full flex justify-center bg-[#FEF1F9] py-[60px] md:py-0">
      <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between">
        {/* 왼쪽 이미지 */}
        <div 
          className={`w-full md:w-1/2 flex justify-center md:justify-end h-full mb-[10px] md:mb-0 mt-[10px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`}
        >
          <img
            src={aboutSection2}
            alt="AR 카메라 폰"
            className="w-full md:w-[700px] h-[370px] md:h-[647px] object-cover"
          />
        </div>

        {/* 오른쪽 텍스트 */}
        <div 
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[80px] space-y-[16px] md:space-y-[50px] mt-8 md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[30px]'}`}>
          <div className="text-[#A019B2] text-[18px] md:text-[24px] leading-[160%] font-pretendard font-normal text-center md:text-left mb-4 md:mb-0">
            컬러렌즈 AR 카메라, <span className="font-bold">폰뷰 (PONVIEW)</span>
          </div>
          <h2 className="text-[24px] md:text-[40px] leading-[140%] font-pretendard font-bold text-black text-center md:text-left">
            내 눈에 어울리는 렌즈<br />AR로 실시간 착용 미리보기
          </h2>
          <p className="text-[16px] md:text-[20px] leading-[160%] font-pretendard font-normal text-black text-center md:text-left">
            실시간 얼굴 인식으로 가상 착용을 지원합니다.<br />
            렌즈 컬러와 어울림을 직접 눈으로 확인해보세요.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutSection2; 